export const amazonRegistryPageData = {
  seo: {
    title: 'Amazon Wedding Registry | Joy',
    content:
      'Discover the ease of creating and sharing your Amazon wedding registry with Joy. Make your special day seamless and convenient for your guests.',
  },
  hero: {
    eyebrow: 'The All-in-One Universal Registry',
    title: 'Your Amazon Wedding Registry With Joy',
    createRegistry: 'Create Registry',
    connectBrandRegistry: 'Connect Amazon Registry',
  },
  shopRegistry: {
    shopTitle: 'Amazon Top Brands',
  },
  shopSearch: {
    title: 'Get it all with an Amazon Wedding Registry With Joy.',
    subTitle:
      'With Joy, your wedding registry is a universal wedding registry. That means you can add products from Amazon’s vast selection, wedding gifts and cash funds from the Joy Shop, or items from any online store. Gift-givers will have one convenient place to shop and you can manage everything in one place from your Joy wedding registry. Already have an Amazon wedding registry?<br/>Connect it to a Joy wedding registry!',
    placeholder: 'Search products and brands',
    submitLabel: 'Search',
  },
  faqList: {
    title: 'Your Amazon Wedding Registry questions, answered.',
  },
} as const;
